import React, { useContext, useEffect, useMemo } from 'react';
import { QuerySocketEvent } from '@trinity/chat';
import { OnTextToSpeechAudioReadyContext, TextToSpeechStateContext } from '@trinity/chat-components/containers/TextToSpeechAudioPlayer/Context.js';
import { useChatQuerySocket } from '@trinity/chat-components/websocket';

type Props = {
  children: React.ReactNode;
  kolSearchId?: number;
  queryId?: number;
  queryIdentifier: string;
};

export const AudioStatusListener = (props: Props) => {
  const audioState = useContext(TextToSpeechStateContext);
  const onAudioReady = useContext(OnTextToSpeechAudioReadyContext);
  // const voicemode = useContext(VoiceModeContext);

  const enabled = useMemo(() => {
    if (!audioState) return false;

    return audioState?.queryId === props.queryId ||
      audioState?.kolSearchId === props.kolSearchId;
  }, [audioState, props.queryId, props.kolSearchId]);

  const socket = useChatQuerySocket(props.queryIdentifier, enabled);

  useEffect(() => {
    if (!socket) return;

    const handleAudioAvailable = (data: { audioUrl: string; queryIdentifier: string }) => {
      if (data.queryIdentifier !== props.queryIdentifier) return;
      onAudioReady(data.audioUrl);
    };

    socket.on(QuerySocketEvent.QueryAudioAvailable, handleAudioAvailable);

    return () => {
      socket.off(QuerySocketEvent.QueryAudioAvailable, handleAudioAvailable);
    };
  }, [socket, props.queryIdentifier, onAudioReady]);

  return (
    <>
      {props.children}
    </>
  );
};

export default AudioStatusListener;
